// Import app styles
import './styles/main.scss';

// Add assets to /dist
import './assets/favicon.ico';

// Polyfills
import 'es6-object-assign/auto'; // IE - Used by vue-js-modals
import 'es6-promise/auto'; // IE - Promise

if (module.hot) {
    module.hot.accept();
}
